export enum ROUTES {
  //Used in `$router.push()`
  home = 'home',
  lists = 'lists',
  list = 'list',
  login = 'login',
  system = "system"
}
